//whether to add a section or not
export const setAddSectionDetail = (value) => {
	return { type: "SET_ADD_SECTION_CLICKED", payload: value };
};

export const setWidgetSelectedVal = (value) => {
	return { type: "SET_WIDGET_SELECTED_VALUE", payload: value };
};
export const setSelectedWidgetCount = (value) => {
	return { type: "SET_SELECTED_WIDGET_COUNT", payload: value };
};
export const setModalVisible = (value) => {
	return { type: "SET_MODAL_VISIBLE", payload: value };
};

export const setAlphaNumeric = (value) => {
	return { type: "SET_ALPHA_NUMERIC", payload: value };
};
